import React from 'react';
import ContactForm from '../components/contact/ContactForm';
import WhatsAppButton from '../components/common/WhatsAppButton';
import './ContactPage.css';

const ContactPage = () => {
    return (
        <div className="contact-page">
            <div className="contact-form-container">
                <ContactForm />
            </div>
            <WhatsAppButton />
        </div>
    );
};

export default ContactPage;